import { get } from 'svelte/store';
import { userid, isProduction } from './utils';
const configsStaging = 'https://beta-sb-app-configs-vlwut6qbsq-lz.a.run.app';
const configsLive = 'https://beta-sb-app-configs-djgqciaueq-ew.a.run.app';
export const apiBase = () => {
  return [true, 'true'].includes(process['env'].PROD_ENV) ? configsLive : configsStaging;
};
export async function listConfigs() {
  const userToken = `?token=${get(userid)}`;
  if (userToken == '?token=undefined') return;

  const url = apiBase() + `/configs/backend/list${userToken}`;
  const res = await fetch(url);
  const json = await res.json();
  return json;
}

export async function createConfig(client) {
  return await postConfig('backend', client, JSON.stringify({ cid: client }));
}
export async function fetchConfig(type, client, name) {
  const userToken = `?token=${get(userid)}`;

  if (userToken == '?token=undefined') return;

  let url = apiBase() + `/configs/${type}/customer/${client}${userToken}`;
  if (name) {
    url += `&fname=${name}`;
  }
  const res = await fetch(url);
  const json = await res.json();
  return json;
}
export async function fetchConfigHistory(type, client) {
  const userToken = `?token=${get(userid)}`;

  if (userToken == '?token=undefined') return;

  const url = apiBase() + `/configs/${type}/list/${client}${userToken}`;
  const res = await fetch(url);
  const json = await res.json();
  return json;
}
export async function postConfig(type, client, data) {
  const userToken = `?token=${get(userid)}`;
  if (userToken == '?token=undefined') return;
  const url = apiBase() + `/configs/${type}/customer/${client}${userToken}`;
  const res = await fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: data,
  });
  const json = await res.json;
  return json;
}
